export var JoinRelationship;
(function (JoinRelationship) {
    JoinRelationship["ONE_TO_MANY"] = "one-to-many";
    JoinRelationship["MANY_TO_ONE"] = "many-to-one";
    JoinRelationship["ONE_TO_ONE"] = "one-to-one";
    JoinRelationship["MANY_TO_MANY"] = "many-to-many";
})(JoinRelationship || (JoinRelationship = {}));
export var ExploreType;
(function (ExploreType) {
    ExploreType["VIRTUAL"] = "virtual";
    ExploreType["DEFAULT"] = "default";
})(ExploreType || (ExploreType = {}));
export var InlineErrorType;
(function (InlineErrorType) {
    InlineErrorType["METADATA_PARSE_ERROR"] = "METADATA_PARSE_ERROR";
    InlineErrorType["NO_DIMENSIONS_FOUND"] = "NO_DIMENSIONS_FOUND";
})(InlineErrorType || (InlineErrorType = {}));
export const isExploreError = (explore) => 'errors' in explore;
export var CustomViewType;
(function (CustomViewType) {
    CustomViewType["VIRTUAL"] = "virtual";
    CustomViewType["WRITE_BACK"] = "write_back";
})(CustomViewType || (CustomViewType = {}));
//# sourceMappingURL=explore.js.map